import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import AuthFormField, { authInputWithIconClass } from './AuthFormField';

interface AuthPasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  name?: string;
  className?: string;
}

const AuthPasswordField: React.FC<AuthPasswordFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder = 'أدخل كلمة المرور',
  autoComplete = 'current-password',
  required,
  name,
  className,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <AuthFormField label={label} htmlFor={id} icon={Lock} className={className}>
      <input
        id={id}
        name={name || id}
        type={visible ? 'text' : 'password'}
        autoComplete={autoComplete}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${authInputWithIconClass} pl-12`}
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 left-0 z-10 flex min-w-11 items-center justify-center px-3 text-slate-500 transition-colors hover:text-[#001848] focus:outline-none focus-visible:text-gold-600"
        aria-label={visible ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'}
        aria-pressed={visible}
        tabIndex={0}
      >
        {visible ? (
          <EyeOff className="h-5 w-5" strokeWidth={2} />
        ) : (
          <Eye className="h-5 w-5" strokeWidth={2} />
        )}
      </button>
    </AuthFormField>
  );
};

export default AuthPasswordField;
